import { Avatar } from "@mui/material";
import BaseCard from "../../../components/ui/BaseCard";
import BaseDigitalSignature from "../../../components/ui/BaseDigitalSignature";
import UserProfileLink from "../../../components/ui/UserProfileLink";

const EngineerSignature = ({ formik, mode, engineer }) => {
  return (
    <BaseCard
      className="pt-4 pb-6 xl:px-16 px-5  rounded-none !mb-[0px] w-full"
      elevation={0}
    >
      <div className="border-bottom mb-8 flex justify-between items-center pb-1">
        <h6 className="!text-primary">Engineer Sign-Off</h6>

        <UserProfileLink
          as="div"
          userId={engineer?.id}
          search="?direct=true"
          className="flex items-center gap-2"
          linkClassName="cursor-pointer hover:underline"
        >
          <Avatar
            src={engineer.profilePicture}
            sx={{ width: 30, height: 30 }}
          />

          <p className="text-base font-medium text-[16px] !text-primary">
            {`${engineer?.firstName} ${engineer?.lastName}`}
          </p>
        </UserProfileLink>
      </div>

      <div className="flex gap-10 w-full ">
        <div
          className={`border rounded w-full mb-4${
            mode === "WRITE" ? "h-52" : "h-auto"
          }`}
        >
          {" "}
          <p className="text-base font-normal ml-3 mt-3">
            Signature <span className="text-xs font-light">(Required)</span>
          </p>
          {mode === "WRITE" ? (
            <BaseDigitalSignature
              defaultSignature={formik.values.engineerSignatureFile}
              handleSignatureCompleted={(image) =>
                formik.setFieldValue("engineerSignatureFile", image)
              }
              onClear={() => {
                formik.setFieldValue("engineerSignatureFile", null);
              }}
            />
          ) : (
            <div className="flex items-center justify-center">
              <img
                src={formik?.values?.engineerSignatureFile}
                alt="Engineer Signature"
                className="object-cover max-h-full max-w-full"
              />
            </div>
          )}
        </div>
        <div className="border rounded w-full">
          <p className="text-base font-normal ml-3 mt-3">
            Comments <span className="text-xs font-light">(If any)</span>
          </p>
          <textarea
            disabled={mode !== "WRITE"}
            className="w-full rounded-md h-36 resize-none p-4  focus:outline-none focus:ring-0 focus:ring-orange-400 text-xs font-[300]"
            id="engineerComment"
            name="engineerComment"
            value={formik.values.engineerComment}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.engineerComment &&
              Boolean(formik.errors.engineerComment)
            }
            helperText={
              formik.touched.engineerComment && formik.errors.engineerComment
            }
          ></textarea>
        </div>
      </div>
    </BaseCard>
  );
};

export default EngineerSignature;
